import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const env = environment;

if (env.production) {
    enableProdMode();
}

platformBrowserDynamic([{ provide: 'ENV', useValue: env }])
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
